import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.matchName
var driverNameT = global.driverNameT
var orderName = global.orderName
var crmServer3 = global.crmServer3
// crm2与crm3兼容
// 根据登陆userId获取车队长的信息
export let QRcodeCDZInfo = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sCompany/QRcodeCDZInfo`, p)
  } else {
  }
}

// 订单列表
export const orderList = p => post(`/${orderName}/sOrder/list`, p)
// 报价单列表
export const sOrderOfferList = p => post(`/${orderName}/sOrderOffer/list`, p)
// 报价
export const sOrderOfferAdd = p => post(`/${orderName}/sOrderOffer/add`, p)
// 报价单删除
export const sOrderOfferDel = p => post(`/${orderName}/sOrderOffer/delete`, p)
// 订单分派
export const wayAssignment = p => post(`/${orderName}/way/assignment`, p)
// 指派货源接收
export const receiveOrder = p => post(`/${orderName}/sOrderOffer/receiveOrder`, p)
// 获取客户列表
export const getRelationCustomer = p => post(`${name}/base/getRelationCustomer`, p)
// 司机报号列表
export const choiceDriverSigninList = p => post(driverName + '/cDriverInfo/choiceDriverSigninList', p)
// 获取基本信息
export const findDictByType = p => post(`/${orderName}/sDict/findDictByType`, p)
// 判断配货单挂靠声明是否合规（贾）
export const checkRel = p => post(driverNameT + '/cDriverVehicleRel/checkRel', p)
// 用于配货上报收款方查询车队长
export const findRelByvhIdAndDriId = p => post(driverNameT + '/cDriverVehicleRel/findRelByvhIdAndDriId', p)
